import styled from "styled-components";

const CardConstructor = ({
  title,
  content,
  aboveTitleContent,
  centered = true,
  width,
  margin,
  ...props
}: {
  [key: string]: any;
  centered?: boolean;
}) => {
  return (
    <Wrapper $width={width} $margin={margin} $centered={centered} {...props}>
      <div className="card-holder">
        <div className="card">
          <div className="card-content black-text">
            {aboveTitleContent}
            <span className="card-title">{title}</span>
            {content}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default CardConstructor;

const Wrapper = styled.div<{
  $centered?: boolean;
  $margin: string;
  $width: string;
}>`
  width: ${({ $width }) => (!$width ? "100%" : $width)};
  margin: ${({ $margin }) => (!$margin ? "unset" : $margin)};
  height: ${({ $centered }) => ($centered ? "100vh" : "auto")};
  display: flex;
  justify-content: center;
  ${({ $centered }) => $centered && `align-items: center;`}
  padding: ${({ $centered }) => ($centered ? "0" : "40px 20px")};

  .card-holder {
    width: 100%;
    max-width: 700px;
  }

  .card {
    border-radius: 15px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  }

  .card-title {
    padding: 18px 0;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .card-content {
    padding: 48px;
  }

  @media only screen and (max-width: 640px) {
    width: 90%;
    height: auto;

    .card-content {
      padding: 20px;
      margin-top: 30px;
      margin-bottom: 85px;
    }
  }
`;
